<script>
import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";

export default {
    name: "BreadCrumbDigest",
    components: {
        AjaxLoad,
    },
    data() {
        return {
            digest: null,
        }
    },
    computed: {
        idProject() {
            return this.$store.getters.breadCrumbs.event?.EPS_PROJECT_ID?.VALUE || null;
        },
        idDigests() {
            return parseInt(this.$route.params.ID_DIGESTS);
        },
        isActive() {
            return !!(this.idProject && this.idDigests)
        },
        breadcrumb() {
            const digest = this.digest;
            return {
                text: this.idDigests ? (digest && digest.name) : 'Новый дайджест',
            };
        },
    },
    mounted() {
        this.$store.commit('UPDATE_BREAD_CRUMBS');
    },
    beforeDestroy() {
        this.$store.commit('UPDATE_BREAD_CRUMBS', {digest: null});
    },
}
</script>

<template>
    <ajax-load
        v-model="digest"
        :active="isActive"
        :url="$apiUrl.getProjectDigestUrl({id_project: idProject, id_digests: idDigests})"
        :transform="response => response.data.data"
        @input="$store.commit('UPDATE_BREAD_CRUMBS', {digest: $event})"
    >
        <router-view></router-view>
    </ajax-load>
</template>

<style scoped lang="scss">

</style>
